"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoActionMenu = void 0;
var react_1 = __importDefault(require("react"));
var styled_1 = require("../styled");
var ActionMenu_1 = require("../../ActionMenu");
var VideoActionMenu = function (_a) {
    var id = _a.id, isInRTE = _a.isInRTE, value = _a.value, inputRef = _a.inputRef, setShowEmbedLinkModal = _a.setShowEmbedLinkModal, onChange = _a.onChange, isUploadedVideo = _a.isUploadedVideo, invert = _a.invert;
    return (react_1.default.createElement(styled_1.StyledActionButtonWrapper, null,
        react_1.default.createElement("div", { style: __assign({}, (isInRTE ? { display: "none" } : {})) },
            react_1.default.createElement(ActionMenu_1.ActionMenu, { popOutOfOverflowHiddenParent: true, ButtonComp: "ButtonPrimary", iconSize: "M", invert: invert, actions: [
                    isUploadedVideo(value) // Only allow user to replace URL when embed method is URL
                        ? {
                            id: "".concat(id, "_uploadNewVideo"),
                            display: "Upload New Video",
                            onClick: function () {
                                onChange(undefined);
                                inputRef.current.click(); // Trigger file explorer popup
                            },
                        }
                        : {
                            id: "".concat(id, "_replaceUrl"),
                            display: "Replace URL",
                            onClick: function (e) {
                                onChange(undefined);
                                setShowEmbedLinkModal(true);
                            },
                        },
                    {
                        display: "Delete",
                        onClick: function () { return onChange(undefined); },
                    },
                ] }))));
};
exports.VideoActionMenu = VideoActionMenu;
